import PropTypes from "prop-types";
import React from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { hidePopup } from "actions/popupActions";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Button } from "cxa-components";
import { logout } from "actions/loginActions";
import CloseIcon from "./CloseButton";
import PopupLight from "./PopupLight";
import messages from "components/messagesDescription";

const Popup = props => {
  const { intl, isActive, hidePopup, element, callback, showClose, isLight } = props;
  const handleClose = () => {
    hidePopup();
    callback &&
      setTimeout(() => {
        if (typeof callback === "function") {
          callback();
        }
      }, 1000);
  };

  return isLight ? (
    <PopupLight {...props} />
  ) : (
    <Modal
      isOpen={isActive}
      onRequestClose={showClose ? hidePopup : handleClose}
      className="popup"
      overlayClassName="popup__overlay"
      closeTimeoutMS={0}
    >
      <div className="content-container">
        {showClose && (
          <div className="hide-icon">
            <Link to="#" onClick={hidePopup}>
              <CloseIcon
                style={{
                  fill: "red",
                }}
              />
            </Link>
          </div>
        )}
        {element}
        <Button primary className="close-button" onClick={handleClose}>
          {intl.formatMessage(messages.okTextDescription)}
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ popup }) => ({
  ...popup,
});

const mapDispatchToProps = {
  hidePopup,
  logout,
};

Popup.propTypes = {
  intl: PropTypes.object,
  isActive: PropTypes.bool,
  hidePopup: PropTypes.func,
  element: PropTypes.element,
  callback: PropTypes.func,
  logout: PropTypes.func,
  showClose: PropTypes.bool,
  isLight: PropTypes.bool,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Popup));



// WEBPACK FOOTER //
// ./components/common/Popup.js